import { event, pageview } from "vue-gtag";
import MixpanelService from "@/scripts/analytics/mixpanel.js";

function getCurrentPagePath() {
    return `${window.location.pathname}${window.location.search}${window.location.hash}`;
}

function buildLandingProperties(properties = {}) {
    return {
        event_group: MixpanelService.MixpanelEventGroups.USER_LIFECYCLE,
        page_path: getCurrentPagePath(),
        ...properties,
    };
}

function isPrerendering() {
    return Boolean(window.__UXFOLIO_PRERENDER__);
}

export function trackLandingEvent(eventName, properties = {}) {
    const eventProperties = buildLandingProperties(properties);

    if (isPrerendering()) {
        return Promise.resolve();
    }

    return MixpanelService.track(eventName, eventProperties);
}

export function trackLandingPageView(source, properties = {}) {
    const page = getLandingPageName();
    const path = window.location.pathname + window.location.search;

    const tracking = trackLandingEvent("LANDING_PAGE_VIEWED", {
        source,
        page,
        ...properties,
    });

    if (!isPrerendering()) {
        try {
            pageview({
                page_path: path,
                page_title: document.title,
                page_location: window.location.href,
            });
        } catch (err) {
            // vue-gtag may be unavailable in some local setups
        }

        if (Array.isArray(window.dataLayer)) {
            window.dataLayer.push({
                event: "landing_page_view",
                page_path: path,
                page_title: document.title,
                landing_source: source,
                landing_page: page,
            });
        }

        if (typeof window.fbq === "function") {
            window.fbq("track", "PageView");
        }
    }

    return tracking;
}

export function getLandingPageName(path = window.location.pathname) {
    if (path.startsWith("/pricing")) {
        return "Pricing";
    }

    if (path.startsWith("/examples")) {
        return "Examples";
    }

    if (path.startsWith("/custom-ux-portfolio")) {
        return "Custom UX Portfolio";
    }

    return "Home";
}

export function trackLandingCtaClick(type, page, section, url, properties = {}) {
    const eventProperties = buildLandingProperties({
        type,
        page,
        section,
        url,
        destination: properties.destination || url,
        ...properties,
    });

    if (isPrerendering()) {
        return Promise.resolve();
    }

    MixpanelService.track("LANDING_CTA_CLICKED", {
        ...eventProperties,
    });

    event("LANDING_CTA_CLICKED", {
        event_category: "Landing",
        event_label: `${page} - ${section} - ${type}`,
        url: eventProperties.url,
        destination: eventProperties.destination,
    });
}
